import lazyLoad from '@loadable/component'
import createPlugin from './createPlugin'

import AccordionRenderer from '@peracto/peracto-blocks-tailwind/dist/content/Accordion/Renderer/AccordionRenderer'

const AccordionForm = lazyLoad(() => import('./Form/AccordionForm'))

const accordionPlugin = settings => {
    return createPlugin({
        Renderer: AccordionRenderer,
        Controls: AccordionForm,
        ...settings,
    })
}

const accordion = accordionPlugin()
export default accordion

export { accordionPlugin }
